import React from 'react';
import { toast } from 'sonner';
import { Check, Package, Share2, CalendarCheck } from 'lucide-react';
import { Button } from '../ui/button';
import { copyStorefrontLink } from './EmptyState';

function Step({ done, icon: Icon, title, body, action, testId }) {
  return (
    <li className="flex items-start gap-4 py-4 border-b border-[#E6E4DD] last:border-0" data-testid={testId}>
      <div className={`shrink-0 w-9 h-9 rounded-full flex items-center justify-center border ${done ? 'bg-[#D4AF37] border-[#D4AF37]' : 'bg-white border-[#E6E4DD]'}`}>
        {done ? <Check className="h-4 w-4 text-white" /> : <Icon className="h-4 w-4 text-stone-400" />}
      </div>
      <div className="flex-1 min-w-0">
        <p className={`text-sm font-medium ${done ? 'text-stone-400 line-through' : 'text-[#1A1A1A]'}`}>{title}</p>
        <p className="text-xs text-stone-500 mt-0.5 leading-relaxed">{body}</p>
      </div>
      {!done && action}
    </li>
  );
}

export function GettingStartedCard({ services, bookings, username, setActiveTab }) {
  const hasServices = services.length > 0;
  const hasBookings = bookings.length > 0;
  if (hasServices && hasBookings) return null;

  const share = async () => {
    const ok = await copyStorefrontLink(username);
    if (ok) toast.success('Booking link copied'); else toast.error('Could not copy the link');
  };

  return (
    <div className="card-surface p-6 mb-6" data-testid="getting-started-card">
      <p className="text-xs uppercase tracking-[0.2em] text-[#D4AF37] mb-1">Getting started</p>
      <h3 className="font-heading text-xl font-medium text-[#1A1A1A] mb-1">Three steps to your first booking</h3>
      <p className="text-sm text-stone-500 mb-2">Most providers finish these in under ten minutes.</p>
      <ol>
        <Step
          done={hasServices} icon={Package} testId="getting-started-step-service"
          title="Add your first service"
          body="Name it, set a price and duration. Clients can only book what they can see."
          action={<Button size="sm" className="btn-primary" onClick={() => setActiveTab('services')} data-testid="getting-started-add-service-btn">Add service</Button>}
        />
        <Step
          done={hasBookings} icon={Share2} testId="getting-started-step-share"
          title="Share your booking link"
          body="Post it on Instagram, WhatsApp or TikTok. Bookings through your own link carry no commission."
          action={username && hasServices ? <Button size="sm" variant="outline" onClick={share} data-testid="getting-started-copy-link-btn">Copy link</Button> : null}
        />
        <Step
          done={hasBookings} icon={CalendarCheck} testId="getting-started-step-booking"
          title="Confirm your first booking"
          body="New requests appear here and in the Bookings tab. You will also get an email."
        />
      </ol>
    </div>
  );
}
